// @flow
/* eslint-disable arrow-body-style */
import React from 'react';
import classNames from 'classnames';
import randomId from 'javascripts/utils/random-id';
import Icon from 'components/_particles/icon/react/Icon';

export type AccordionItemProps = {
  id?: string,
  prefix?: React.Node,
  headline?: React.Node,
  children?: React.Node,
  open?: boolean,
  onToggleOpen?: () => void,
  className?: string,
};

const AccordionItem = ({
  id,
  children,
  headline,
  prefix,
  open = true,
  className,
  onToggleOpen,
}: AccordionItemProps): React$MixedElement => {
  const itemId = id || randomId();
  return (
    <article
      className={classNames(
        'accordion__item',
        open && 'accordion__item--open',
        className
      )}
    >
      <h3 className="accordion__header" id={`accordion-item-${itemId}`}>
        <button
          className="accordion__toggle"
          type="button"
          aria-expanded={open}
          aria-controls={`accItem1--${itemId}-content`}
          id={`accItem1--${itemId}-headline`}
          onClick={() => onToggleOpen?.()}
        >
          <span className="accordion__toggle-prefix">{prefix}</span>
          <span className="accordion__toggle-label">{headline}</span>
          <Icon
            icon="bw-chevron-bottom-line"
            className="accordion__toggle-icon"
            ariaHidden
          />
        </button>
      </h3>
      {open && (
        <div
          className="accordion__content accordion__content--visible"
          id={`accItem1--${itemId}-content`}
          aria-labelledby={`accItem1--${itemId}-headline`}
        >
          <div className="text">{children}</div>
        </div>
      )}
    </article>
  );
};

export default AccordionItem;
